import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const getProfileApi = createApi({
  reducerPath: "getProfileApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        const token = Cookies.get('authToken');
      if (token) {
        headers.set("Authorization", `${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getprofileapi: builder.query({
      query: () => `/user/dashboard/details`,
    }),
  }),
});

export const { useGetprofileapiQuery } = getProfileApi;